import { Trans, useLingui } from "@lingui/react/macro";
import { lazy, Suspense } from "react";

import { useSharedProfile } from "~/hook/overlay/useSharedProfile.ts";
import { navigator } from "~/service/dom.ts";
import { createDraggableSheet } from "~/ui/base/DraggableSheet.tsx";

const QRCodeSVG = lazy(() =>
  import("qrcode.react").then((mod) => ({ default: mod.QRCodeSVG })),
);

export const SharedProfileSheet = createDraggableSheet(({ close, titleId }) => {
  const { t } = useLingui();
  const { handleCopy, handleShare, myEmail, shareUrl } =
    useSharedProfile(close);

  return (
    <div className="pt-8 pb-20">
      <h1 className="sr-only" id={titleId}>
        <Trans>프로필 공유하기</Trans>
      </h1>
      <div className="flex size-full flex-col items-center">
        <Suspense
          fallback={
            <div className="size-52 animate-pulse rounded-md bg-zinc-100 shadow-lg dark:bg-zinc-800" />
          }
        >
          <QRCodeSVG
            bgColor="#fff"
            className="rounded-2xl shadow-lg"
            fgColor="#000"
            size={208}
            value={shareUrl}
          />
        </Suspense>
        <p className="pt-5 text-xl font-bold text-black dark:text-white">
          @{myEmail}
        </p>
        <div className="flex w-52 gap-3 pt-8">
          {[
            navigator?.share && {
              key: "share",
              onClick: handleShare,
              text: t`공유하기`,
            },
            navigator?.clipboard.writeText && {
              key: "copy",
              onClick: handleCopy,
              text: t`복사하기`,
            },
          ]
            .filter((props) => !!props)
            .map(
              (props: { key: string; onClick: () => void; text: string }) => (
                <button
                  className="block flex-1 rounded-md border-2 border-black bg-white px-2 py-1 text-sm font-medium text-zinc-900 active:opacity-60 dark:border-white dark:bg-zinc-800 dark:text-zinc-100"
                  key={props.key}
                  onClick={props.onClick}
                  type="button"
                >
                  {props.text}
                </button>
              ),
            )}
        </div>
      </div>
    </div>
  );
});
